import { render, staticRenderFns } from "./playbook-instances-statuses.vue?vue&type=template&id=ed0818e8&"
import script from "./playbook-instances-statuses.vue?vue&type=script&lang=js&"
export * from "./playbook-instances-statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports